import type { PageProps, PayallLifePageProps } from "@/types";
import React, { FC } from "react";
import { NextPage } from "../next-page";
import {
  PayallLifeHero,
  PayallLifeMission,
  PayallLifeValues,
} from "../payall-life";

export const PayallLife: FC<PageProps<PayallLifePageProps>> = (props) => {
  return (
    <div>
      <PayallLifeHero
        label={props.meta.translation.payallLife.hero.label}
        title={props.data.title}
        description={props.data.description}
        gallery={props.data.gallery}
      />
      <PayallLifeMission content={props.data.missionQuote} />
      <PayallLifeValues content={props.data.values} />
      <NextPage {...props.data.nextPage} />
    </div>
  );
};
